import { render, staticRenderFns } from "./Ben.vue?vue&type=template&id=35b7cedc&scoped=true&"
import script from "./Ben.vue?vue&type=script&lang=js&"
export * from "./Ben.vue?vue&type=script&lang=js&"
import style0 from "./Ben.vue?vue&type=style&index=0&id=35b7cedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7cedc",
  null
  
)

export default component.exports